import type { FaireProductEntity } from "../../entity_types/product";

export const p_29qpvvnrpb: FaireProductEntity = {
  token: "p_29qpvvnrpb",
  type: "product",
  name: "Mahjong Keychain | Heart Charm & Rope",
  brandToken: "b_k2cxrcr92s",
  brandName: "Frem",
  imageUrl:
    "https://cdn.faire.com/fastly/2ffd55cfe83c08d4b582e8c693d8fa042272b71e1df462fda8e4b57ec568ca69.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7a251a29c3599cff469bb6363433cb10d569ea9fbb08513f86f66ecb1ddeb16a.jpeg",
    "https://cdn.faire.com/fastly/99d324a5f8dcc95ac93f4509d5c5fec323081db3f07dcf0508bb795438202e32.jpeg",
    "https://cdn.faire.com/fastly/ec46279f173e8534246d63771b8e08e68d91a6b277aacc46440a55db76cb1367.jpeg",
    "https://cdn.faire.com/fastly/29c2d6ef884a6379fafbdcec15e0c93aab3a2a960cc080b52817c0d76c495fc0.jpeg",
    "https://cdn.faire.com/fastly/ce46628dc956963a5c4e072f9c518c2a00b2b7d18aa60f6bbd60b20232608123.jpeg",
    "https://cdn.faire.com/fastly/be5d87826ce780831e30a24edb9c1d92cc84db1b78601846723665b5a5baad93.jpeg",
    "https://cdn.faire.com/fastly/7e34199ca49ff4299963a9189b68a1cdf026e63900ec07ed527db08aa163027d.jpeg",
    "https://cdn.faire.com/fastly/e37577e11c746a2f4bec1366add82fb6ceacef83cbcffa72cbfa4313356d7c5b.jpeg",
    "https://cdn.faire.com/fastly/e2f055363e8c8a648c7a294f25c94c30d8cb801fd53e757ec359bebcc2884b7d.jpeg",
    "https://cdn.faire.com/fastly/40208d4c73978272926afeed3f3d36a762f5acf14d7a2243c2e6e0eeb1bc0b7f.jpeg",
  ],
  priceDollars: 11.5,
  description:
    "Description\n\nElevate your everyday essentials with this pink rope keychain featuring a Mahjong tile charm and glossy gold heart detail. Stylish, durable, and lightweight—perfect for keys, bags, or as a unique gift for Mahjong lovers.\n\nKey Features\n\n * Mahjong-Inspired Design – Features a decorative Mahjong tile charm \n * Chic Gold Hardware – Includes a polished heart charm and secure clasp \n * Durable Rope Build – Strong woven cord for everyday use \n * Lightweight & Functional – Easy to attach to keys, purses, or backpacks \n * Perfect Gift Idea – Great for Mahjong enthusiasts or accessory lovers \n * Trendy & Playful Style – Aesthetic mix of cute and modern design ",
  tags: [],
  msrpDollars: 34.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:31.742Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
